define(["require", "exports", "tslib", "mobx-react", "react", "react-dropzone", "../../model/services", "./index"], function (require, exports, tslib_1, mobx_react_1, React, react_dropzone_1, services_1, index_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FileUploadView = void 0;
    React = tslib_1.__importStar(React);
    react_dropzone_1 = tslib_1.__importDefault(react_dropzone_1);
    const mebibyteAsBytes = 1048576;
    let FileUploadView = exports.FileUploadView = class FileUploadView extends React.Component {
        constructor(props) {
            super(props);
            Object.defineProperty(this, "onDrop", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (acceptedFiles, rejectedFiles) => {
                    this.setState({
                        files: acceptedFiles
                    });
                }
            });
            Object.defineProperty(this, "upload", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    if (this.state.files.length === 0) {
                        return;
                    }
                    for (const file of this.state.files) {
                        const reader = new FileReader();
                        reader.onload = () => {
                            if (this.props.onFileLoaded) {
                                const base64 = reader.result.match(/^.*;base64,(.*)/)[1];
                                this.props.onFileLoaded(file, base64);
                            }
                        };
                        reader.onprogress = (p) => {
                        };
                        reader.onerror = (error) => {
                            services_1.EventManager.Instance.emitError(new Error("File upload failed: " + reader.error.message));
                        };
                        reader.readAsDataURL(file);
                    }
                    this.setState({
                        files: []
                    });
                }
            });
            this.state = {
                files: []
            };
        }
        render() {
            return (React.createElement(index_1.VGroup, { style: { width: "100%" } },
                React.createElement(react_dropzone_1.default, { multiple: this.props.multiple, maxSize: this.props.maxSize, accept: this.props.accept, onDrop: this.onDrop }, ({ getRootProps, getInputProps, isDragActive }) => {
                    return (React.createElement("div", Object.assign({}, getRootProps(), { className: isDragActive ? "dropzone dropzoneActive" : "dropzone" }),
                        React.createElement("input", Object.assign({}, getInputProps())),
                        React.createElement("div", { className: "dropzoneText" },
                            "Click here to upload a file, or drag and drop files from your computer.",
                            React.createElement("div", { className: "br" }),
                            "Max file size: ",
                            Math.round(this.props.maxSize / mebibyteAsBytes),
                            " MiB")));
                }),
                React.createElement("div", { className: "br" }),
                React.createElement(index_1.CtaButton, { label: "Upload", onClick: this.upload, disabled: this.state.files.length === 0 }),
                this.state.files && this.state.files.length > 0
                    ? React.createElement(index_1.VGroup, null,
                        React.createElement("h4", null, "File(s) to upload:"),
                        this.state.files.map((file, index) => React.createElement("div", { key: file.name }, file.name)))
                    : null));
        }
    };
    Object.defineProperty(FileUploadView, "defaultProps", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            maxSize: 5 * mebibyteAsBytes,
            accept: "application/pdf,image/*,application/zip,text/plain,application/excel,application/vnd.ms-excel,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    });
    exports.FileUploadView = FileUploadView = tslib_1.__decorate([
        mobx_react_1.observer
    ], FileUploadView);
});
